export const INTEGRATION_WORD_CONSTANTS = {
  INTEGRATION: 'integration',
  INTEGRATION_WORD: 'word',
  INTEGRATION_OUTLOOK: 'outlook',
  CHECK_USER_CONTENT_MODE: '?mode=checkUserConsent',
  WORD_AUTHORIZE: '?mode=mswordAuthorize',
  OUTLOOK_AUTHORIZE: '?mode=outlookAuthorize',
  DEVICE_ID: 'device_id',
  LOGIN: '?mode=login&integration=',
  MS_WORD: 'msword',
}